// extracted by mini-css-extract-plugin
export var box = "index-module--box--2FFZ5";